import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-66423a4c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "feishu-login"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "login_qrcode_container"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login_qrcode_text"
}, "请使用飞书扫描二维码登录", -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
import { ElMessage } from 'element-plus';
import { OAuthController } from '@/api/system/index';

import { ref, onMounted, onUnmounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  ...{
    name: 'FeishuLogin'
  },
  __name: 'login',
  props: {
    bindSocial: {
      type: Boolean,
      default: false
    },
    dialog: {}
  },
  emits: ['success', 'error'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const fsInstance = ref();
    const emit = __emit;
    onMounted(() => {
      // STATE可以根据需要替换为自己的值，并在后台做校验
      const goto = 'https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=' + process.env.VUE_APP_FEISHU_CLIENT_ID + '&redirect_uri=' + process.env.VUE_APP_FEISHU_REDIRECT_URI + '&response_type=code&state=STATE';
      const QRLoginObj = window.QRLogin({
        id: 'login_qrcode_container',
        goto: goto,
        width: '350',
        height: '280',
        // 可选的，二维码html标签的style属性
        style: 'border:none;'
      });
      const handleMessage = event => {
        // 使用 matchOrigin 和 matchData 方法来判断 message 和来自的页面 url 是否合法
        if (QRLoginObj.matchOrigin(event.origin) && QRLoginObj.matchData(event.data)) {
          console.log('飞书登录回调', event);
          OAuthController.redirect({
            url: `${goto}&tmp_code=${event.data.tmp_code}`
          }).then(res => {
            console.log('飞书CODE', res);
            if (res) {
              if (props.bindSocial) {
                OAuthController.bind({
                  source: 'feishu',
                  code: res.data
                }).then(r => {
                  console.log('飞书绑定成功', r);
                  if (props.dialog) {
                    ElMessage.success('绑定成功');
                    props.dialog.submit(r);
                  }
                  emit('success', r);
                }).catch(e => {
                  emit('error', e);
                });
              } else {
                OAuthController.login({
                  source: 'feishu',
                  code: res.data
                }).then(r => {
                  console.log('飞书登录成功', r);
                  if (props.dialog) {
                    props.dialog.submit(r);
                  }
                  emit('success', r);
                }).catch(e => {
                  console.warn('飞书登录失败');
                  emit('error', e);
                });
              }
            }
          }).catch(e => {
            console.warn('飞书登录失败', e);
            emit('error', e);
          });
        }
      };
      window.addEventListener('message', handleMessage);
      fsInstance.value = {
        destroy: () => {
          window.removeEventListener('message', handleMessage);
        }
      };
    });
    onUnmounted(() => {
      if (fsInstance.value) fsInstance.value.destroy();
      fsInstance.value = null;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
    };
  }
});